import { render, staticRenderFns } from "./error_404.vue?vue&type=template&id=3b144067&"
import script from "./error_404.vue?vue&type=script&lang=js&"
export * from "./error_404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports